import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { ActivatedRoute, ParamMap, Router } from '@angular/router'; 
import { ClientService } from '../../../services/client.service';
import { CatalogService } from '../../../services/catalog.service';
import { PetService } from '../../../services/pet.service'; 
import Swal from 'sweetalert2'; 
declare var $: any;

@Component({
  selector: 'ngx-work-pet-note',
  templateUrl: './pet-note.component.html' 
})
export class PetNoteComponent implements OnInit {
  private _pet_no: number;
  snote_startDate: string = '';
  snote_endDate: string = '';
  noteType: number = 0
  newNote:{note_sequence:number ,note_text: string, note_type: number} = {note_sequence:0,note_text: '', note_type: 0}

  @Input() set pet_no(value: number) {
    this._pet_no = value;
  }

  get pet_no(): number {
    return this._pet_no;
  }

  constructor(
    public clientService: ClientService,
    public petService: PetService,
    public catalogService: CatalogService,
  ) { }

  ngOnInit(): void {
    // Claim the shared "current pet" tracker with whatever pet_no was actually
    // bound to this instance, so a stale value left over from a previous,
    // unrelated page (changePet is a BehaviorSubject shared app-wide) doesn't
    // immediately overwrite it via the subscription below.
    this.petService.changePetVar(this.pet_no);

    this.petService.changePet
      .subscribe(message => {
        this.pet_no = message;
        this.getPetNotes(this.pet_no,0,'','');
    });
  }

  getPetNotes(pet_no, note_type, startDate, endDate){
    this.petService.getPetNote(pet_no, note_type, startDate, endDate).then(() => {
      this.petService.pet_notes.forEach(element => {
        element.note_date = this.formatDateString(element.note_date)
      })
    }); 
  }

  search_click(){
    this.getPetNotes(this.pet_no, this.noteType, this.snote_startDate, this.snote_endDate); 
  }

  add(){
    $('#saveNoteModal').modal('toggle');
  }  

  formatDateString(dateString) {
    // Create a Date object from the input string
    const date = new Date(dateString);
  
    // Extract the month, day, and year
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-indexed
    const day = String(date.getDate()).padStart(2, '0');
    const year = date.getFullYear();
  
    // Format the date as MM-dd-YYYY
    return `${month}-${day}-${year}`;
  }
  
  saveNote(){ 
    this.petService.pet_note.pet_no = this.pet_no;
    this.petService.pet_note.note_text = this.newNote.note_text + ' -- ' + this.clientService.userData.employee_name;
    this.petService.pet_note.note_type = this.newNote.note_type; 

    this.petService.creupPetNote().then(() => {
      Swal.fire({
        title: 'Note saved successfully',
        didOpen: () => {
          this.getPetNotes(this.pet_no,0,'',''); 
          this.newNote.note_text = '';
          this.newNote.note_type = 0;
        },
      })
      $('#saveNoteModal').modal('toggle');
    } );
  }

}
